import { createContext, useContext, useState } from "react";

export const GridContext = createContext({});

export const useGrid = () => useContext(GridContext);